import { render, staticRenderFns } from "./elastic-product-filter.vue?vue&type=template&id=2bbbf8f3&scoped=true"
import script from "./elastic-product-filter.vue?vue&type=script&lang=js"
export * from "./elastic-product-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbf8f3",
  null
  
)

export default component.exports